import { render, staticRenderFns } from "./contentUserCreate.vue?vue&type=template&id=633cdb24&"
import script from "./contentUserCreate.vue?vue&type=script&lang=js&"
export * from "./contentUserCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports